import Logo from "../assets/images/Logo.webp";
import LightLogo from "../assets/images/LightLogo.webp";
import Profile from "../assets/images/profile.png";
import plusIcon from "../assets/images/plusIcon.png";
import minesIcon from "../assets/images/minesIcon.png";
import service from "../assets/images/service.png";
import blur from "../assets/images/blur.jpg";
import noImg from "../assets/images/noimg.png";
import SidebarLogo from '../assets/images/SidebarLogo.svg'
const assets = {
  getFile: (name) => assets.files[name],
  files: {
    noImg,
    service,
    Logo,
    LightLogo,
    Profile,
    plusIcon,
    minesIcon,
    blur,
    SidebarLogo
  },
};

export const useAssets = () => assets;
